import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { combineReducers } from 'redux-immutable'
import { routerMiddleware } from 'connected-react-router/immutable'
import rootReducer, { indexReducer } from 'reducers/index.js'
import promiseHandler from 'middleware/promiseHandler'
import rootSaga from 'sagas'
import createSagaMiddleware from 'redux-saga'
import history from './history'

/* eslint-disable-next-line no-shadow */
export function createStoreWithMiddleWare(rootReducer, preloadedState) {
  const sagaMiddleware = createSagaMiddleware()

  const composeEnhancers =
    process.env.NODE_ENV === 'development' &&
    !!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          ...(process.env.REACT_APP_REDUX_TRACING && {
            trace: true,
            traceLimit: 25,
          }),
        }) || compose
      : compose

  const enhanced = composeEnhancers(
    applyMiddleware(
      thunk,
      promiseHandler,
      sagaMiddleware,
      routerMiddleware(history)
    )
  )

  const store = createStore(rootReducer, preloadedState, enhanced)

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        /* eslint-disable-next-line global-require */
        const nextRootReducer = require('./reducers/index')
        store.replaceReducer(nextRootReducer)
      })
    }
  }
  sagaMiddleware.run(rootSaga)

  return store
}

export default createStoreWithMiddleWare(rootReducer)

// without history
// ? better way to do this
export function storybookStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware()

  const composeEnhancers = !!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

  const enhanced = composeEnhancers(
    applyMiddleware(thunk, promiseHandler, sagaMiddleware)
  )

  const initialReducer = combineReducers({
    ...indexReducer,
  })

  const store = createStore(initialReducer, preloadedState, enhanced)

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        /* eslint-disable-next-line global-require */
        const nextRootReducer = require('./reducers/index')
        store.replaceReducer(nextRootReducer)
      })
    }
  }
  sagaMiddleware.run(rootSaga)

  return store
}
